module.exports = __webpack_public_path__ + "static/media/promote-ad.bc5d7dba.svg";